// extracted by mini-css-extract-plugin
module.exports = {"root":"bookings_root__OHspS","header":"bookings_header__o6JA2","body":"bookings_body__WSVcR","footer":"bookings_footer__3wIvk"};